export default __webpack_public_path__ + "static/media/productivity.69eb17cb.png";